module.exports = "/_next/static/media/33427899473fb5721115b207f125ab38.svg";